module.exports = __webpack_public_path__ + "static/media/loginVector.f5ac19ba.png";